<template>
  <div class="ln-phone-login">
    <Form ref="form">
      <Field
        v-model="phone"
        placeholder="请输入您的11位手机号码"
        :rules="[{ required: true, message: '请填写手机号码' }]"
      >
        <i slot="left-icon" class="iconfont iconphone"></i>
      </Field>
      <check-code v-model="code" :params="codeParams"></check-code>

      <div class="bottom">
        <Row class="login-row">
          <Button class="login-btn" block type="info" native-type="submit" @click="login">
            进入游戏
          </Button>
        </Row>
        <Row class="login-row">
          <span style="font-size: 14px;float: right;color: #1989fa" @click="changeLogin">账号登录</span>
        </Row>

        <Row class="login-row link-wrap" style="justify-content:center;clear: both;">
          <AgreeRegister v-model="agree"></AgreeRegister>
          <span style="font-size: 13px;margin-top: 7px;margin-left:5px;">同意游戏</span><span class="link" style="vertical-align:center;margin-left: 0px;margin-top: 7px;" @click="openProtocal(1)">《用户协议》</span>
          <span style="font-size: 13px;margin-top: 7px">及</span> <span style="font-size: 13px;margin-top: 7px;" @click="openProtocal(2)" class="link">《隐私协议》</span>
        </Row>

      </div>
    </Form>

    <!-- 用户协议弹窗 -->
    <div v-if="isProto" class="lngame_proto">
      <div class="lngame_proto_con" style="height:100%;width:100%">
        <div style="height:90%;padding:15px">
          <iframe :src="userProtocol" style="width:100%;height:100%" frameborder="0"></iframe>
        </div>
      </div>
      <van-icon style="position:absolute;right:0;top:0;right:10px;top:10px;z-index:3000" name="cross" @click="closeProto" />
    </div>

  </div>
</template>

<script>
import { Form, Field, Button, Col, Row, Dialog } from 'vant';
import { commonMixin } from '@/mixin';
import AgreeRegister from '@/components/AgreeRegister';
import CheckCode from '@/components/CheckCode';
import server from '@/server';
import { getUrlParams, getTopDomain } from '@/utils';
export default {
  name: 'ln-phone-login',
  mixins: [commonMixin],
  components: { Form, Field, Button, Row, CheckCode, AgreeRegister },
  data() {
    return {
      phone: '',
      code: '',
      agree: Boolean(localStorage.getItem('agreeProt')) || false,
      isProto: false,
      userProtocol: ''
    };
  },
  computed: {
    codeParams() {
      return {
        mobile: this.phone,
        type: 1 /* 登录 */
      };
    }
  },
  created() {
    localStorage.setItem('wx_tip', 1); // 微信首次收藏提示
  },
  methods: {
    login() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      this.formCheck('form').then(() => {
        const params = {
          mobile: this.phone,
          code: this.code
        };
        server.loginPhone(params);
      });
    },
    changeLogin() {
      this.$store.commit('SHOW', {
        name: 'Login'
      })
    },
    // 打开用户协议
    openProtocal(type) {
      this.isProto = true;
      this.userProtocol = type == 1 ? `${getTopDomain('apisdk')}/uc/user/user_protocol?appid=${getUrlParams('appid')}` : `${getTopDomain('apisdk')}/uc/user/privacy_protocol?appid=${getUrlParams('appid')}`
    },
    closeProto() {
      this.isProto = false;
    }
  }
};
</script>
<style lang="scss">
/* @import url() */
.ln-phone-login {
}
</style>
